export var ShadowLightType;
(function (ShadowLightType) {
    ShadowLightType[ShadowLightType["DirectionLight"] = 0] = "DirectionLight";
    ShadowLightType[ShadowLightType["SpotLight"] = 1] = "SpotLight";
    ShadowLightType[ShadowLightType["PointLight"] = 2] = "PointLight";
})(ShadowLightType || (ShadowLightType = {}));
